import React from 'react'
import StagesManager from '../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import Responsive from '../components/Responsive';

// import { nanoid } from 'nanoid';
// import DiagramEditor from '../components/views/DiagramEditor';
import { checkTranslation, conditionalWidth, translate } from '../utils/useful';
import HttpServices from '../utils/Http.services'
// import Main from './search/Main';
import SearchHome from './search/SearchHome';
import SearchMain from './search/SearchMain';
import { getBoundingClientRect } from '../utils/functions';
import { TypeAnimation } from 'react-type-animation';
import { nanoid } from 'nanoid';


class Search extends React.Component {
    state = {
        searchResults: [],
        searchedApplets: [],

        search: '',
        tab: 0,
        back: '',
        tabs: [
            { key: 'all', name: '{{lang}}All', img: '/assets/icons/tower/applets.svg' },
            { key: 'hubs', name: '{{lang}}Hubs', img: '/assets/icons/tower/hubs.svg' },
            { key: 'applets', name: '{{lang}}Applets', img: '/assets/icons/tower/applets.svg' },
            // { key: 'products', name: '{{lang}}Products', img: '/assets/icons/tower/products.svg' },
        ],
        tab: 'all',
        currentStage: 'Home',
        // hubs: [
        //     { name: 'Paityn Carder', description: 'description', img: '/assets/icons/rooms/peoples/person2.svg' },
        //     { name: 'Madelyn Schleifer', description: 'description', img: '/assets/icons/rooms/peoples/person3.svg' },
        //     { name: 'Ruben Mango', description: 'description', img: '/assets/icons/rooms/peoples/person4.svg' },
        //     { name: 'Leo Herwitz', description: 'description', img: '/assets/icons/rooms/peoples/person5.svg' },
        //     { name: 'Jaylon Westervelt', description: 'description', img: '/assets/icons/rooms/peoples/person6.svg' },
        //     { name: 'Alfonso Baptista', description: 'description', img: '/assets/icons/rooms/peoples/person7.svg' },
        //     { name: 'Haylie Geidt', description: 'description', img: '/assets/icons/rooms/peoples/person8.svg' },
        //     { name: 'Lydia Dias', description: 'description', img: '/assets/icons/rooms/peoples/person9.svg' },
        //     { name: 'Livia Rhiel Madsen', description: 'description', img: '/assets/icons/rooms/peoples/person10.svg' },
        // ],
        // trending: [
        //     { name: 'Tehran' },
        //     { name: 'Party applet' },
        //     { name: 'Valentine' },
        //     { name: 'Christmas gifts' },
        //     { name: 'Festival of lights' },
        //     { name: 'Twitter' },
        //     { name: 'Iran' },
        // ]
    }

    componentDidMount() {
        this.init()
    }

    init = () => {

        this.getLicensedHubs()
        this.getHubSearchHistory()
    }

    getLicensedHubs = () => {


        HttpServices.request('getLicencedHubs', {}, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ licencedHubs: fetchResult.info }, () => {

            })
        })

    }

    getHubSearchHistory = () => {


        HttpServices.request('getHubSearchHistory', {}, (fetchResult, fetchError) => {

            if (fetchError) {
                return
            }
            this.setState({ searchHistory: fetchResult.info }, () => {

            })
        })

    }



    addToSearchHistory = (item) => {

        let body = item

        HttpServices.request('addToSearchHistory', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

            let searchHistory = this.state.searchHistory ?? []
            let found = false

            searchHistory.forEach((element, index) => {
                if (fetchResult?.info?._id == element._id) {
                    found = true
                    searchHistory[index] = fetchResult.info
                }
            });

            if (!found) {
                searchHistory.push(fetchResult.info)
            }

            searchHistory.sort((a, b) => a.uDate > b.uDate ? -1 : 1)

            this.setState({ searchHistory })

        })
    }


    searchYonnect = () => {

        let data = {}
        let text = this.state.search
        data.text = text
        data.type = this.state.tab

        if (text && text.trim() != '') {
            HttpServices.request('searchYonnect', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                this.setState({ searchResults: fetchResult }, () => {

                    if (this.state.currentPage != 'Search') {
                        this.setState({ currentPage: 'Search' })
                        this.changeStage('Search')
                    }
                })
            })
        } else {
            if (this.state.currentPage != 'Main') {
                this.setState({ currentPage: 'Main' })
                this.changeStage('Main')
            }
        }
    }



    changeValue = (event) => {
        this.setState({ search: event.target.value }, () => {
            // let toolbar = this.toolbar
            // toolbar.style.height = '43.11px';
            // toolbar.style.height = 'auto';
            // toolbar.style.height = (toolbar.offsetHeight) + "px";
            // let height = getBoundingClientRect(toolbar).height
            // this.setState({ toolbarHeight: height })
            let id = nanoid()
            this.searchId = id
            setTimeout(() => {
                if (this.searchId == id) {
                    this.searchYonnect(this.state.search)
                }
            }, 500);
        })
    }

    changeStage = (stage) => {
        if (this.state.search.length > 0) {
            this.stagesManager.changeStage("Search")
        }
        else {
            this.stagesManager.changeStage("Main")
        }
        this.setState({ back: stage, currentStage: stage })
    }

    render() {
        return (
            <div className="w-100 white-bg window-content-radius h-100 d-flex flex-column scroll-no-scrollbar" style={{}} >
                <div className='w-100 flexc  py-1 position-sticky px-3 top-0' ref={el => this.header = el} style={{ background: 'linear-gradient(90deg, #76b852 0%, #8DC26F 100%)', zIndex: 1 }}>
                    <div className='flexcc mrd-3'>
                        <img className='' src='/logo-w.svg' alt='' height={30} />
                    </div>
                    <div className='flex flex-column '>

                        <p className='weight-600 white' style={{ fontSize: 20, lineHeight: 1, background: 'linear-gradient(90deg, #fff 0%, #ffffff 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{translate('Yonnect')}</p>
                        <p className='weight-600 white' style={{ fontSize: 11, background: 'linear-gradient(90deg, #fff 0%, #ffffff 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{translate('Search & explore')}</p>

                        {/* <p className='weight-400 font-size-14' style={{ color: 'rgba(255, 255, 255, 0.7)' }}>{translate('& Explore')}</p> */}
                    </div>
                    <div className={"navbarSearch2 mx-2 mt-1 pld-4 prd-2 br-100 " + conditionalWidth(this.props.width, { xs: 'w-100', md: 'w-50' })} ref={el => this.searchbox = el} style={{ boxShadow: '0px 0px 20px #10101020', border: '1px solid #eee' }}>
                        <div className='d-flex flexc cursor-pointer'>
                            <img className='invert  mrd-2' width={25} src="/assets/icons/search-gray.svg" />
                            <input className="w-100 text-semibold font-size-16" onChange={e => this.changeValue(e)} value={this.state.search} type="text" style={{ backgroundColor: 'transparent', padding: '12px 0px' }} />

                            {(this.state.search == null || this.state.search.trim() == '') && (
                                <div className='position-absolute top-0 h-100 w-100 flexc' style={{ left: 45, pointerEvents: 'none', color: '#777', fontSize: 12 }}>
                                    <TypeAnimation
                                        sequence={[
                                            // Same substring at the start will only be typed out once, initially
                                            translate('Search for hubs, applets, and etc'),
                                            1000, // wait 1s before replacing "Mice" with "Hamsters"
                                            translate('Search for people and businesses'),
                                            1000,
                                            translate('Search for products and services'),
                                            1000,
                                            translate('Search for posts, hashtags, and etc'),
                                            1000
                                        ]}
                                        wrapper="span"
                                        speed={50}
                                        style={{ fontSize: '13px', display: 'inline-block' }}
                                        repeat={Infinity}
                                    />
                                </div>
                            )}
                            {/* <div className='flexcc ' style={{ background: "linear-gradient(90deg, rgb(127 24 143 / 17%) 0%, rgb(120 38 255 / 25%) 100%)", borderRadius: 50 }}>
                                <img className='invert m-1' width={25} src="/assets/icons/search-gray.svg" />
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="w-100 d-flex flex-column" >
                    <div style={{ background: 'linear-gradient(90deg, #76b852 0%, #8DC26F 100%)', }} ref={el => this.toolbar = el}>
                        {/* {this.state.search.length > 0 && */}
                        <div className='flexc p-2' style={{ background: 'rgba(255, 255, 255, 0.04)' }}>
                            {this.state.tabs.map((item, index) => {
                                return (
                                    <button className={' flexcc pld-4 prd-4 py-1 br-5 mrd-2 transition '} onClick={() => { this.setState({ tab: item.key }, () => this.searchYonnect()) }} style={{ background: this.state.tab == item.key ? '#10101030' : '' }}>
                                        {/* <img src={item.img} width={18} className='mrd-1' /> */}
                                        <p className='font-size-14 white text-semibold' style={{}}>{checkTranslation(item.name)}</p>
                                    </button>
                                )
                            })}
                        </div>
                        {/* } */}
                    </div>
                    <div className='flexc flex-column' style={{ height: (this.state.search.length > 0 && this.state.toolbarHeight) ? `calc(100% - ${this.state.toolbarHeight}px` : '100%' }}>
                        {/* <Responsive width={this.props.width} height={'100%'} media={{ xs: '100%', md: "7", lg: "8" }}> */}
                        <div className={"bg-white br-10 w-100 " + conditionalWidth(this.props.width, { xs: '', md: 'py-3' })} style={{ maxWidth: 800 }}>
                            <StagesManager ref={el => this.stagesManager = el} fast="true" >
                                <SearchMain stage={0} stageName="Main" width={this.props.width} language={this.props.language} changeStage={this.changeStage} addNewWindow={this.props.addNewWindow} licencedHubs={this.state.licencedHubs} searchHistory={this.state.searchHistory} addToSearchHistory={this.addToSearchHistory} />
                                <SearchHome stage={1} stageName="Search" width={this.props.width} language={this.props.language} changeStage={this.changeStage} searchResults={this.state.searchResults} addNewWindow={this.props.addNewWindow} tab={this.state.tab} addToSearchHistory={this.addToSearchHistory} />
                            </StagesManager>
                        </div>
                        {/* </Responsive> */}
                        {/* <Responsive width={this.props.width} height={'100%'} media={{ xs: 'none', md: "5", lg: "4" }}>
                            <div className='p-3' style={{}} >
                                <div className='br-10 bg-white' style={{}} >
                                    {this.state.hubs.map((item, index) => {
                                        return (
                                            <div className="px-3 py-2 flexc w-100 br-10 box-shadow-20 bg-white mb-3 " style={{ transition: 'all 0.5s', cursor: 'pointer', }}>
                                                <img className='mrd-3' src={item.img} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} />
                                                <div>
                                                    <p className="mb-0 font-size-14" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{item.name}</p>
                                                    <p className="mb-0 font-size-12" style={{ color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{item.description}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className='br-10 bg-white box-shadow-20' >
                                    <div className='bb-gray'>
                                        <div className='d-flex flexc p-2'>
                                            <img className='prd-1' src='/assets/icons/tower/trending.svg' />
                                            <p className='font-size-15 main-c5' style={{}}>{translate("Trending searches")}</p>
                                        </div>
                                    </div>
                                    <div style={{ flexWrap: 'wrap' }} className='flexc p-2'>
                                        {this.state.trending.map((item, index) => {
                                            return (
                                                <div className='flexc trending-text br-5 px-2 py-1 mrd-2 mb-2'>
                                                    <div className={' br-50 mrd-2 ' + (`dot` + (index % 4 + 1))}></div>
                                                    <p>{item.name}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Responsive> */}
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Search);
